<div class="card border-0 shadow-sm" style="min-height: 300px;">
    <div class="card-header text-light border-0 bg-secondary">Retry upload</div>
    <div class="card-body" style="min-height: 40vh">
        <div class="mt-1">
            <label class="btn btn-default btn-sm text-center btn-file p-4 py-2 border-secondary w-100"
            style="border: 1px dotted">
            <i class="fa fa-cloud-upload fa-3x text-secondary"></i>
            <input type="file" style="display: none" (change)="uploadFiles($event)" #inputFile />
        </label>
        </div>

        <div class="card border-secondary mt-2">
            <div class="cadr-header bg-secondary">
                <span class="text-light ms-1">Existing File Details </span>
            </div>
            <table class="table table-stripped mb-0 pb-0" style="border-bottom-width: 0px;">
                <tbody>
                    <tr>
                        <td style="cursor: default">
                            <span> File Name </span>
                        </td>
                        <td style="cursor: default">
                            <span>
                                {{ data.displayName }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style="cursor: default">
                            <span> Uploaded Document Id </span>
                        </td>
                        <td style="cursor: default">
                            <span>
                                {{ data.uploadedDocumentId }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="card border-warning mt-2" *ngIf="selectedFile">
            <div class="cadr-header bg-warning">
                <span class="text-dark ms-1">New File Details </span>
            </div>
            <table class="table table-stripped mb-0 pb-0">
                <tbody>
                    <tr>
                        <td style="cursor: default">
                            <span>{{ selectedFile.name }}</span>
                            <div class="d-flex" *ngIf="uploadProgress > 0">
                                <span class="progress col-11" *ngIf="!uploadError">
                                    <span class="progress-bar" role="progressbar"
                                        [ngStyle]="{ width: uploadProgress + '%' }" [attr.aria-valuenow]="uploadProgress"
                                        aria-valuemin="0" aria-valuemax="100">
                                        <span *ngIf="uploadProgress > 1">
                                            {{ uploadProgress }}%
                                        </span>
                                    </span>
                                </span>
                                <span class="progress col-11" *ngIf="uploadError">
                                    <span class="progress-bar bg-danger text-light px-2" role="progressbar"
                                        [ngStyle]="{ width: '100%' }" aria-valuenow="100" aria-valuemin="0"
                                        aria-valuemax="100">
                                        {{ uploadError }}
                                    </span>
                                </span>
                                <span class="col-1">
                                    <i class="fa-solid fa-circle-check text-success ms-1" *ngIf="uploadProgress == 100"></i>
                                </span>
                            </div>
                        </td>
                        <td>{{ formatBytes(selectedFile.size) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
    <div class="card-footer border-0">
        <span class="float-end">
            <button class="btn btn-warning btn-sm text-light" (click)="upload()">
                Upload &nbsp;
                <span *ngIf="isFileUploading"><i class="fas fa-circle-notch fa-spin"></i></span>
            </button>
            <button class="ms-2 btn btn-secondary btn-sm text-light" [disabled]="isFileUploading"
                (click)="dialogRef.close()">
                Close
            </button>
        </span>
    </div>
</div>

